const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Bar */}


      {/* Hero Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">Disclaimer</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our resin artworks are handcrafted with love and care. However, we would like to clarify a few important points:
          </p>
          <p className="text-sm text-gray-500 mt-4">Last updated: 9 June, 2025</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            {/* General Disclaimer */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Handmade Nature</h2>
              <p className="text-gray-600 mb-4">
                All our products are 100% handmade and may contain small imperfections like minor bubbles, uneven textures, or slight color variations. These are part of the charm and uniqueness of handmade resin art, and are not considered defects.</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">2. Digital vs. Final Product</h2>
              <p className="text-gray-600 mb-4">
                The final product may slightly vary from the digital references, previews, or mockups shared during customization. Factors such as lighting, curing conditions, and pigment blending may result in minor differences.</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">3. Customer Responsibility</h2>
              <p className="text-gray-600 mb-4">
                We are not responsible for dissatisfaction due to:<br/>> A personal change of mind after the order has been placed<br/>> Misunderstanding of size, color tone, or photo quality<br/>> Low-resolution or unclear images provided for embedding</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">4. Color Display Notice</h2>
              <p className="text-gray-600 mb-4">Colors may appear different on screen than in reality due to varying lighting conditions and screen settings.</p>
            </div>
<hr/>


            
            <div className="mb-12 mt-4">
              <div className="bg-gray-50 rounded-lg p-6">
             <h2 className="text-2xl font-bold text-gray-900 mt-4 mb-4">Thank you for choosing RangDesaaj – Crafted with Resin, Customized with Love.</h2>
              <p className="text-gray-600 mb-4">If you have any concerns or need further clarification, please contact us before placing your order.</p>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  )
}

export default Disclaimer
